import * as React from 'react'
import { CurrentCompanyStore } from '../../../../../../stores/CurrentCompanyStore'
import { ComplianceStore } from '../../ComplianceStore'
import { SKTransactionsReport } from './SKTransactionsReport'
import { observer } from 'mobx-react'

interface Props {
  currentCompanyStore: CurrentCompanyStore
  complianceStore: ComplianceStore
}

interface State {
  isLoading: boolean
  showOldReportSidebar: boolean
}

@observer
export class Saskatchewan extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)
    this.state = {
      isLoading: false,
      showOldReportSidebar: false,
    }
  }

  render() {
    return (
      <div>
        <SKTransactionsReport
          complianceStore={this.props.complianceStore}
          currentCompanyStore={this.props.currentCompanyStore}
        />
      </div>
    )
  }
}
